import React from "react";
import { JobAttendance } from "../../components";

export default function Attendance() {
  return (
    <React.Fragment>
      <h2 className={"content-block"}>Job Attendance</h2>
      <JobAttendance />
    </React.Fragment>
  );
}
